var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.5V3.16667C16.5 2.72464 16.3244 2.30072 16.0118 1.98816C15.6993 1.67559 15.2754 1.5 14.8333 1.5H9M16.5 11.5V11.6433C16.4999 12.0853 16.3242 12.5092 16.0117 12.8217L12.8217 16.0117C12.5092 16.3242 12.0853 16.4999 11.6433 16.5H11.5M16.5 11.5H13.1667C12.7246 11.5 12.3007 11.6756 11.9882 11.9882C11.6756 12.3007 11.5 12.7246 11.5 13.1667V16.5M11.5 16.5H3.16667C2.72464 16.5 2.30072 16.3244 1.98816 16.0118C1.67559 15.6993 1.5 15.2754 1.5 14.8333V9M9.83333 4.83333H13.1667M7.33333 8.16667H13.1667M4.83333 11.5H8.16667M4 1.5V4M4 6.5V4M4 4H6.5M4 4H1.5",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNote);
export default __webpack_public_path__ + "static/media/add-note.749890848b02bb438641b85ab24fad9c.svg";
export { ForwardRef as ReactComponent };